<template>
    <MainContainer>
        <div class="fibu-mitgliederbeitraege-detail">
            <h2>
                <template v-if="isNew">Neue Mitgliedsbeitrag-Art anlegen</template>
                <template v-else>Mitgliedsbeitrag <b-badge>{{ data.text }}</b-badge> bearbeiten</template>
            </h2>
            <div class="fibu-mitgliedsbeitraege-detail-fields">
                <FormGroupBuilder
                    :fields="ioFields"
                    :data="data"
                    :refresh="validationRefresh"
                />

                <template v-if="isNew">
                    <b-button
                        type="submit"
                        class="total-btn mr-1"
                        variant="primary"
                        :disabled="busy"
                        @click="dataProvide"
                    >
                        <template v-if="!busy">Speichern</template>
                        <template v-else>
                            <Spinner small variant="light" />
                        </template>
                    </b-button>
                </template>
                <template v-else>
                    <b-button
                        v-if="checkRight('write')"
                        type="submit"
                        class="total-btn mr-1"
                        variant="primary"
                        :disabled="busy"
                        @click="dataProvide"
                    >
                        <template v-if="!busy">Speichern</template>
                        <template v-else>
                            <Spinner small variant="light" />
                        </template>
                    </b-button>
                </template>
                <b-button
                    type="cancel"
                    to="/fibu/mitgliedsbeitraege/verwalten"
                    class="total-btn"
                    variant="outline-secondary"
                >
                    <template v-if="checkRight('write')">Abbrechen</template>
                    <template v-else>Zurück</template>
                </b-button>
            </div>
        </div>
        <div
            v-if="isNew"
            class="mt-4"
        >
            <b-alert variant="warning" show class="d-flex justify-content-between align-items-center">
                <span>Neue Stati müssen zunächst unter <i>"Mitglieder / Status"</i> angelegt werden.</span>
                <span>
                    <b-button
                        :to="{ path: '/status' }"
                        size="sm"
                    >
                        Status anlegen
                    </b-button>
                </span>
            </b-alert>
        </div>
    </MainContainer>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory";
import Spinner from "@/components/Spinner/Spinner";
import MainContainer from "@/components/MainContainer/MainContainer";
import Size from "@/mixins/Size/Size";
import Validation from "@/mixins/Validation/Validation";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import Rights from "@/mixins/Rights/Rights";

const MitgliedsbeitraegeApi = ApiFactory.get('fiBuMitgliedsbeitraegeApi');
const BuchungskontoApi = ApiFactory.get('fibuBuchungskonto');
import Toaster from "@/mixins/Toaster/Toaster";
const StatusApi = ApiFactory.get('status');

export default {
    name: "FiBuMitgliederbeitaegeDetail",
    mixins: [Size, Validation, Rights, Toaster],
    components: { MainContainer, FormGroupBuilder, Spinner },
    data() {
        return {
            data: {},
            buchungskonto_id: {
                busy: false,
                options: []
            },
            buchungskontoForUeberzahlungMV: {
                busy: false,
                options: []
            },
            buchungskontoForUeberzahlungSP: {
                busy: false,
                options: []
            },
            status: {
                busy: false,
                options: []
            },
            busy: false,
            id: this.$route.params.id
        }
    },
    mounted() {
        if(this.isNew) {
            this.fetchStatus();
        } else {
            this.fetchMitgliedsbeitrag();
        }
        this.fetchBuchungskonten();
    },
    methods: {
        async fetchMitgliedsbeitrag() {
            this.busy = true;

            const response = await MitgliedsbeitraegeApi.get(this.id);

            if(response.ok) {
                this.registerRights(response);
                this.cleanPayload(response.json);

                this.data = response.json;
            }
            this.busy = false;
        },
        async fetchStatus() {
            this.status.busy = true;

            const response = await StatusApi.getallStati();

            if(response.ok) {
                let options = response.json.collection.map(item => {
                    return {
                        text: `${item.value} - ${item.name}`,
                        value: item.value
                    }
                });
                options.splice(0,0, {text: 'Bitte wählen Sie einen Status', value: null});
                this.status.options = options;
                if(this.isNew) {
                    this.$set(this.data, 'status', null);
                }
            }
            this.status.busy = false;
        },
        async fetchBuchungskonten() {
            this.buchungskonto_id.busy = true;

            const response = await BuchungskontoApi.get();

            if(response.ok) {
                let options = response.json.collection.map(item => {
                    return {
                        text: `${item.kontonr} - ${item.text}`,
                        value: item.id
                    }
                });
                options.splice(0,0, {text: 'Bitte wählen Sie ein Buchungskonto', value: null});
                this.buchungskonto_id.options = options;
                this.buchungskontoForUeberzahlungMV.options = options;
                this.buchungskontoForUeberzahlungSP.options = options;
                if(this.isNew) {
                    this.$set(this.data, 'buchungskonto_id', null);
                    this.$set(this.data, 'buchungsKontoForUeberzahlungMV', null);
                    this.$set(this.data, 'buchungsKontoForUeberzahlungSP', null);
                }
            }
            this.buchungskonto_id.busy = false;
        },
        async dataProvide() {
            this.busy = true;

            let response = null;
            if(this.isNew) {
                response = await MitgliedsbeitraegeApi.post(this.id, this.data);
            } else {
                response = await MitgliedsbeitraegeApi.put(this.id, this.data);
            }

            if(response.ok) {
                this.makeToast(
                    "Erfolgreich gespeichert",
                    "Die Änderungen wurden erfolgreich in der Datenbank gespeichert"
                );

                this.$router.push({
                    path: '/fibu/mitgliedsbeitraege/verwalten'
                })
            } else {
                this.handleValidationData(response, this.ioFields);
            }

            this.busy = false;
        },
        cleanPayload(json) {
            Object.keys(json).forEach(key => {
                if (key.startsWith("_")) {
                    delete json[key];
                }
            });
        },
    },
    computed: {
        isNew() {
            return this.$route.params.id === 'new';
        },
        ioFields() {
            if(this.isNew && !this.data.status) {
                return {
                    status: {
                        key: 'status',
                        label: 'Status Nr. / Bezeichnung',
                        type: 'select',
                        required: true,
                        options: this.status.options
                    }
                }
            } else if (this.isNew && this.data.status) {
                return {
                    status: {
                        key: 'status',
                        label: 'Status Nr. / Bezeichnung',
                        type: 'select',
                        required: true,
                        options: this.status.options
                    },
                    beitrag: {
                        key: 'beitrag',
                        label: 'Beitrag',
                        type: 'fibuamountinput',
                        min: 0
                    },
                    beitragspflichtig: {
                        key: 'beitragspflichtig',
                        label: 'beitragspflichtig',
                        type: 'checkbox',
                        checked_value: '1',
                        unchecked_value: '0'
                    },
                    buchungskonto_id: {
                        key: 'buchungskonto_id',
                        label: 'Buchungskonto-Zuordnung',
                        type: 'select',
                        options: this.buchungskonto_id.options,
                        required: true
                    },
                    buchungskontoForUeberzahlungMV: {
                        key: 'ueberzahlungenMV',
                        label: 'Spendenkonto bei Überzahlungen / MV',
                        type: 'select',
                        options: this.buchungskonto_id.options,
                        required: true
                    },
                    buchungskontoForUeberzahlungSP: {
                        key: 'ueberzahlungenSP',
                        label: 'Spendenkonto bei Überzahlungen / SP',
                        type: 'select',
                        options: this.buchungskonto_id.options,
                        required: true
                    }
                }
            } else {
                return {
                    status: {
                        key: 'status',
                        label: 'Status Nr.',
                        type: 'mitgliederinput',
                        disabled: true,
                    },
                    text: {
                        key: 'text',
                        label: 'Bezeichnung',
                        type: 'mitgliederinput',
                        disabled: true
                    },
                    beitrag: {
                        key: 'beitrag',
                        label: 'Beitrag',
                        type: 'fibuamountinput',
                        min: 0
                    },
                    beitragspflichtig: {
                        key: 'beitragspflichtig',
                        label: 'beitragspflichtig',
                        type: 'checkbox',
                        checked_value: '1',
                        unchecked_value: '0'
                    },
                    buchungskonto_id: {
                        key: 'buchungskonto_id',
                        label: 'Buchungskonto-Zuordnung',
                        type: 'select',
                        options: this.buchungskonto_id.options,
                        required: true
                    },
                    buchungskontoForUeberzahlungMV: {
                        key: 'ueberzahlungen',
                        label: 'Spendenkonto bei Überzahlungen / MV',
                        type: 'select',
                        options: this.buchungskonto_id.options,
                        required: true
                    },
                    buchungskontoForUeberzahlungSP: {
                        key: 'ueberzahlungen',
                        label: 'Spendenkonto bei Überzahlungen / SP',
                        type: 'select',
                        options: this.buchungskonto_id.options,
                        required: true
                    }
                }
            }
        }
    },
}
</script>